import { BaseModel } from "./BaseModel";

export class FindingType extends BaseModel {
  schema = "/constant/finding_type";
  constructor(params) {
    return super(params, "/constant/finding_type");
  }
}
